<img *ngIf="imageSrc" [src]="imageSrc" alt="empty" />
<div class="title">
    <ng-content select="[title]"></ng-content>
</div>
<div class="message">
    <ng-content select="[message]"></ng-content>
</div>
<div *ngIf="helpCenterLink.display">
    Not sure where to start? <a (click)="openHelpCenter()">Visit our Help Center</a> to learn more
    and connect with our customer success team.
</div>
